import { DismissalSchedule } from '@shared/utils/dismissal-schedule/dismissal-schedule.interface';

const STORAGE_KEY_PREFIX = 'starting-price-banner-dismissed';
// The banner is shown twice: from login until the first close, then again a week later until the second close.
export const STARTING_PRICE_BANNER_DISMISSAL_SCHEDULE: DismissalSchedule = {
  repeatAfterDays: 7,
  maxDismissals: 2,
};

export function getStartingPriceBannerStorageKey(contractId: string): string {
  return `${STORAGE_KEY_PREFIX}:${contractId}`;
}
